
import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import { Button } from '@mui/material';

const ERROR_IMAGE_URL = "https://cdn-icons-png.flaticon.com/512/564/564619.png";

function ErrorComponent({ error }) {
  return (
    <div style={{ padding: 32, textAlign: 'center', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <img
        src={ERROR_IMAGE_URL}
        alt="Error"
        style={{
          width: 120, height: 120,
          marginBottom: 24, opacity: 0.75
        }}
      />
      <h1 style={{marginBottom: '0.5rem'}}>¡Ups! Hubo un error inesperado</h1>
      <pre style={{ color: "var(--color-danger)" }}>{error?.message || "Error desconocido"}</pre>
      <Button onClick={() => window.location.reload()} variant='contained' sx={{mt: 4}}>Volver al inicio</Button>
    </div>
  );
}

const router = createBrowserRouter(
  [
    {
      path: '*',
      element: <App />,
      errorElement: <ErrorComponent />,
      children: [
        { path: '', element: <App /> },
        { path: 'seguimiento', element: <App /> },
        { path: 'reportes', element: <App /> },
        { path: 'administrar', element: <App /> },
        { path: 'usuarios', element: <App /> },
        { path: 'horarios', element: <App /> },
        { path: 'configuración', element: <App /> },
        { path: 'login', element: <App /> },
        { path: '*', element: <App /> }
      ]
    }
  ],
  // {
  //   future: {
  //     v7_startTransition: true,     // ⚡ previene el warning de startTransition
  //     v7_relativeSplatPath: true    // ✅ previene el warning de rutas splat
  //   }
  // }
);

export default router;
